import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { GenerateQrFields } from '../helpers';

export const useGenerateQrFormValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  return {
    [GenerateQrFields.REGION_ID]: [requiredRule],
    [GenerateQrFields.TYPE]: [requiredRule],
  };
};
